import {fromJS} from 'immutable';

export const loadReduxLocalStorageState = () => {
    try {
        const serializedState = localStorage.getItem('reduxState');
        if (serializedState === null) {
            return undefined;
        } else {
            return fromJS(JSON.parse(serializedState));
        }
    }
    catch (err) {
        return undefined;
    }
};

export const saveReduxStateToLocalStorage = (state, propsToDiscard) => {
    try {
        const jsState = state.toJS();

        propsToDiscard.forEach((prop) => delete jsState[prop]);

        jsState['user']['initialData']['isFetched'] = 0

        const serializedState = JSON.stringify(jsState);
        localStorage.setItem('reduxState', serializedState);
    } catch (err) {
        // Ignore errors
    }
};



// WEBPACK FOOTER //
// ./src/store/reduxLocalStorage.js